import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as et } from "../../_mixins/use-rtl.js";
import tt from "./styles/index.cssr.js";
import { getDefaultPageSize as at, createPageItemsInfo as nt } from "./utils.js";
import it from "../../_mixins/use-config.js";
import pe from "../../_mixins/use-theme.js";
import ot from "../../_mixins/use-locale.js";
import ne from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { smallerSize as ie } from "../../_utils/naive/prop.js";
import { createKey as r } from "../../_utils/cssr/index.js";
import { useThemeClass as rt } from "../../_mixins/use-css-vars-class.js";
import { resolveSlot as st } from "../../_utils/vue/resolve-slot.js";
import oe from "../../input/src/Input.js";
import lt from "../../select/src/Select.js";
import y from "../../_internal/icon/src/Icon.js";
import re from "../../_internal/icons/Forward.js";
import se from "../../_internal/icons/Backward.js";
import le from "../../_internal/icons/FastForward.js";
import de from "../../_internal/icons/FastBackward.js";
import ue from "../../_internal/icons/More.js";
import dt from "../../popselect/src/Popselect.js";
import { warn as ut, warnOnce as ce } from "../../_utils/naive/warn.js";
import ct from "../styles/light.js";
import { call as R } from "../../_utils/vue/call.js";
import { defineComponent as ft, watchEffect as Q, computed as p, h as i, Fragment as fe, nextTick as mt } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as F, toRef as me } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useAdjustedTo as pt } from "../../_utils/composable/use-adjusted-to.js";
const gt = Object.assign(Object.assign({}, pe.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: pt.propTo,
  showQuickJumpDropdown: {
    type: Boolean,
    default: !0
  },
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  /** @deprecated */
  onPageSizeChange: [Function, Array],
  /** @deprecated */
  onChange: [Function, Array]
}), Ht = ft({
  name: "Pagination",
  props: gt,
  slots: Object,
  setup(t) {
    process.env.NODE_ENV !== "production" && Q(() => {
      t.pageCount !== void 0 && t.itemCount !== void 0 && ut("pagination", "`page-count` and `item-count` should't be specified together. Only `item-count` will take effect."), t.onPageSizeChange && ce("pagination", "`on-page-size-change` is deprecated, please use `on-update:page-size` instead."), t.onChange && ce("pagination", "`on-change` is deprecated, please use `on-update:page` instead.");
    });
    const {
      mergedComponentPropsRef: n,
      mergedClsPrefixRef: l,
      inlineThemeDisabled: U,
      mergedRtlRef: g
    } = it(t), h = pe("Pagination", "-pagination", tt, ct, t, l), {
      localeRef: E
    } = ot("Pagination"), N = F(null), V = F(t.defaultPage), m = F(at(t)), d = ne(me(t, "page"), V), v = ne(me(t, "pageSize"), m), b = p(() => {
      const {
        itemCount: e
      } = t;
      if (e !== void 0)
        return Math.max(1, Math.ceil(e / v.value));
      const {
        pageCount: a
      } = t;
      return a !== void 0 ? Math.max(a, 1) : 1;
    }), u = F("");
    Q(() => {
      t.simple, u.value = String(d.value);
    });
    const I = F(!1), P = F(!1), S = F(!1), D = F(!1), W = () => {
      t.disabled || (I.value = !0, k());
    }, L = () => {
      t.disabled || (I.value = !1, k());
    }, q = () => {
      P.value = !0, k();
    }, K = () => {
      P.value = !1, k();
    }, J = (e) => {
      c(e);
    }, C = p(() => nt(d.value, b.value, t.pageSlot, t.showQuickJumpDropdown));
    Q(() => {
      C.value.hasFastBackward ? C.value.hasFastForward || (I.value = !1, S.value = !1) : (P.value = !1, D.value = !1);
    });
    const G = p(() => {
      const e = E.value.selectionSuffix;
      return t.pageSizes.map((a) => typeof a == "number" ? {
        label: `${a} / ${e}`,
        value: a
      } : a);
    }), X = p(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.inputSize) || ie(t.size);
    }), Y = p(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.selectSize) || ie(t.size);
    }), Z = p(() => (d.value - 1) * v.value), H = p(() => {
      const e = d.value * v.value - 1, {
        itemCount: a
      } = t;
      return a !== void 0 && e > a - 1 ? a - 1 : e;
    }), $ = p(() => {
      const {
        itemCount: e
      } = t;
      return e !== void 0 ? e : (t.pageCount || 1) * v.value;
    }), _ = et("Pagination", g, l);
    function k() {
      mt(() => {
        var e;
        const {
          value: a
        } = N;
        a && (a.classList.add("transition-disabled"), (e = N.value) === null || e === void 0 || e.offsetWidth, a.classList.remove("transition-disabled"));
      });
    }
    function c(e) {
      if (e === d.value)
        return;
      const {
        "onUpdate:page": a,
        onUpdatePage: M,
        onChange: B,
        simple: ae
      } = t;
      a && R(a, e), M && R(M, e), B && R(B, e), V.value = e, ae && (u.value = String(e));
    }
    function O(e) {
      if (e === v.value)
        return;
      const {
        "onUpdate:pageSize": a,
        onUpdatePageSize: M,
        onPageSizeChange: B
      } = t;
      a && R(a, e), M && R(M, e), B && R(B, e), m.value = e, b.value < d.value && c(b.value);
    }
    function x() {
      if (t.disabled)
        return;
      const e = Math.min(d.value + 1, b.value);
      c(e);
    }
    function ee() {
      if (t.disabled)
        return;
      const e = Math.max(d.value - 1, 1);
      c(e);
    }
    function o() {
      if (t.disabled)
        return;
      const e = Math.min(C.value.fastForwardTo, b.value);
      c(e);
    }
    function te() {
      if (t.disabled)
        return;
      const e = Math.max(C.value.fastBackwardTo, 1);
      c(e);
    }
    function w(e) {
      O(e);
    }
    function A() {
      const e = Number.parseInt(u.value);
      Number.isNaN(e) || (c(Math.max(1, Math.min(e, b.value))), t.simple || (u.value = ""));
    }
    function j() {
      A();
    }
    function f(e) {
      if (!t.disabled)
        switch (e.type) {
          case "page":
            c(e.label);
            break;
          case "fast-backward":
            te();
            break;
          case "fast-forward":
            o();
            break;
        }
    }
    function T(e) {
      u.value = e.replace(/\D+/g, "");
    }
    Q(() => {
      d.value, v.value, k();
    });
    const z = p(() => {
      const {
        size: e
      } = t, {
        self: {
          buttonBorder: a,
          buttonBorderHover: M,
          buttonBorderPressed: B,
          buttonIconColor: ae,
          buttonIconColorHover: ge,
          buttonIconColorPressed: he,
          itemTextColor: ve,
          itemTextColorHover: be,
          itemTextColorPressed: we,
          itemTextColorActive: Ce,
          itemTextColorDisabled: ke,
          itemColor: xe,
          itemColorHover: Fe,
          itemColorPressed: Pe,
          itemColorActive: Se,
          itemColorActiveHover: ze,
          itemColorDisabled: Me,
          itemBorder: Be,
          itemBorderHover: Ie,
          itemBorderPressed: ye,
          itemBorderActive: Re,
          itemBorderDisabled: Ne,
          itemBorderRadius: $e,
          jumperTextColor: Oe,
          jumperTextColorDisabled: Ae,
          buttonColor: je,
          buttonColorHover: Te,
          buttonColorPressed: Ue,
          [r("itemPadding", e)]: Ee,
          [r("itemMargin", e)]: Ve,
          [r("inputWidth", e)]: De,
          [r("selectWidth", e)]: Je,
          [r("inputMargin", e)]: He,
          [r("selectMargin", e)]: _e,
          [r("jumperFontSize", e)]: Qe,
          [r("prefixMargin", e)]: We,
          [r("suffixMargin", e)]: Le,
          [r("itemSize", e)]: qe,
          [r("buttonIconSize", e)]: Ke,
          [r("itemFontSize", e)]: Ge,
          [`${r("itemMargin", e)}Rtl`]: Xe,
          [`${r("inputMargin", e)}Rtl`]: Ye
        },
        common: {
          cubicBezierEaseInOut: Ze
        }
      } = h.value;
      return {
        "--n-prefix-margin": We,
        "--n-suffix-margin": Le,
        "--n-item-font-size": Ge,
        "--n-select-width": Je,
        "--n-select-margin": _e,
        "--n-input-width": De,
        "--n-input-margin": He,
        "--n-input-margin-rtl": Ye,
        "--n-item-size": qe,
        "--n-item-text-color": ve,
        "--n-item-text-color-disabled": ke,
        "--n-item-text-color-hover": be,
        "--n-item-text-color-active": Ce,
        "--n-item-text-color-pressed": we,
        "--n-item-color": xe,
        "--n-item-color-hover": Fe,
        "--n-item-color-disabled": Me,
        "--n-item-color-active": Se,
        "--n-item-color-active-hover": ze,
        "--n-item-color-pressed": Pe,
        "--n-item-border": Be,
        "--n-item-border-hover": Ie,
        "--n-item-border-disabled": Ne,
        "--n-item-border-active": Re,
        "--n-item-border-pressed": ye,
        "--n-item-padding": Ee,
        "--n-item-border-radius": $e,
        "--n-bezier": Ze,
        "--n-jumper-font-size": Qe,
        "--n-jumper-text-color": Oe,
        "--n-jumper-text-color-disabled": Ae,
        "--n-item-margin": Ve,
        "--n-item-margin-rtl": Xe,
        "--n-button-icon-size": Ke,
        "--n-button-icon-color": ae,
        "--n-button-icon-color-hover": ge,
        "--n-button-icon-color-pressed": he,
        "--n-button-color-hover": Te,
        "--n-button-color": je,
        "--n-button-color-pressed": Ue,
        "--n-button-border": a,
        "--n-button-border-hover": M,
        "--n-button-border-pressed": B
      };
    }), s = U ? rt("pagination", p(() => {
      let e = "";
      const {
        size: a
      } = t;
      return e += a[0], e;
    }), z, t) : void 0;
    return {
      rtlEnabled: _,
      mergedClsPrefix: l,
      locale: E,
      selfRef: N,
      mergedPage: d,
      pageItems: p(() => C.value.items),
      mergedItemCount: $,
      jumperValue: u,
      pageSizeOptions: G,
      mergedPageSize: v,
      inputSize: X,
      selectSize: Y,
      mergedTheme: h,
      mergedPageCount: b,
      startIndex: Z,
      endIndex: H,
      showFastForwardMenu: S,
      showFastBackwardMenu: D,
      fastForwardActive: I,
      fastBackwardActive: P,
      handleMenuSelect: J,
      handleFastForwardMouseenter: W,
      handleFastForwardMouseleave: L,
      handleFastBackwardMouseenter: q,
      handleFastBackwardMouseleave: K,
      handleJumperInput: T,
      handleBackwardClick: ee,
      handleForwardClick: x,
      handlePageItemClick: f,
      handleSizePickerChange: w,
      handleQuickJumperChange: j,
      cssVars: U ? void 0 : z,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const {
      $slots: t,
      mergedClsPrefix: n,
      disabled: l,
      cssVars: U,
      mergedPage: g,
      mergedPageCount: h,
      pageItems: E,
      showSizePicker: N,
      showQuickJumper: V,
      mergedTheme: m,
      locale: d,
      inputSize: v,
      selectSize: b,
      mergedPageSize: u,
      pageSizeOptions: I,
      jumperValue: P,
      simple: S,
      prev: D,
      next: W,
      prefix: L,
      suffix: q,
      label: K,
      goto: J,
      handleJumperInput: C,
      handleSizePickerChange: G,
      handleBackwardClick: X,
      handlePageItemClick: Y,
      handleForwardClick: Z,
      handleQuickJumperChange: H,
      onRender: $
    } = this;
    $ == null || $();
    const _ = L || t.prefix, k = q || t.suffix, c = D || t.prev, O = W || t.next, x = K || t.label;
    return i("div", {
      ref: "selfRef",
      class: [`${n}-pagination`, this.themeClass, this.rtlEnabled && `${n}-pagination--rtl`, l && `${n}-pagination--disabled`, S && `${n}-pagination--simple`],
      style: U
    }, _ ? i("div", {
      class: `${n}-pagination-prefix`
    }, _({
      page: g,
      pageSize: u,
      pageCount: h,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null, this.displayOrder.map((ee) => {
      switch (ee) {
        case "pages":
          return i(fe, null, i("div", {
            class: [`${n}-pagination-item`, !c && `${n}-pagination-item--button`, (g <= 1 || g > h || l) && `${n}-pagination-item--disabled`],
            onClick: X
          }, c ? c({
            page: g,
            pageSize: u,
            pageCount: h,
            startIndex: this.startIndex,
            endIndex: this.endIndex,
            itemCount: this.mergedItemCount
          }) : i(y, {
            clsPrefix: n
          }, {
            default: () => this.rtlEnabled ? i(re, null) : i(se, null)
          })), S ? i(fe, null, i("div", {
            class: `${n}-pagination-quick-jumper`
          }, i(oe, {
            value: P,
            onUpdateValue: C,
            size: v,
            placeholder: "",
            disabled: l,
            theme: m.peers.Input,
            themeOverrides: m.peerOverrides.Input,
            onChange: H
          })), " /", " ", h) : E.map((o, te) => {
            let w, A, j;
            const {
              type: f
            } = o;
            switch (f) {
              case "page":
                const z = o.label;
                x ? w = x({
                  type: "page",
                  node: z,
                  active: o.active
                }) : w = z;
                break;
              case "fast-forward":
                const s = this.fastForwardActive ? i(y, {
                  clsPrefix: n
                }, {
                  default: () => this.rtlEnabled ? i(de, null) : i(le, null)
                }) : i(y, {
                  clsPrefix: n
                }, {
                  default: () => i(ue, null)
                });
                x ? w = x({
                  type: "fast-forward",
                  node: s,
                  active: this.fastForwardActive || this.showFastForwardMenu
                }) : w = s, A = this.handleFastForwardMouseenter, j = this.handleFastForwardMouseleave;
                break;
              case "fast-backward":
                const e = this.fastBackwardActive ? i(y, {
                  clsPrefix: n
                }, {
                  default: () => this.rtlEnabled ? i(le, null) : i(de, null)
                }) : i(y, {
                  clsPrefix: n
                }, {
                  default: () => i(ue, null)
                });
                x ? w = x({
                  type: "fast-backward",
                  node: e,
                  active: this.fastBackwardActive || this.showFastBackwardMenu
                }) : w = e, A = this.handleFastBackwardMouseenter, j = this.handleFastBackwardMouseleave;
                break;
            }
            const T = i("div", {
              key: te,
              class: [`${n}-pagination-item`, o.active && `${n}-pagination-item--active`, f !== "page" && (f === "fast-backward" && this.showFastBackwardMenu || f === "fast-forward" && this.showFastForwardMenu) && `${n}-pagination-item--hover`, l && `${n}-pagination-item--disabled`, f === "page" && `${n}-pagination-item--clickable`],
              onClick: () => {
                Y(o);
              },
              onMouseenter: A,
              onMouseleave: j
            }, w);
            if (f === "page" && !o.mayBeFastBackward && !o.mayBeFastForward)
              return T;
            {
              const z = o.type === "page" ? o.mayBeFastBackward ? "fast-backward" : "fast-forward" : o.type;
              return o.type !== "page" && !o.options ? T : i(dt, {
                to: this.to,
                key: z,
                disabled: l,
                trigger: "hover",
                virtualScroll: !0,
                style: {
                  width: "60px"
                },
                theme: m.peers.Popselect,
                themeOverrides: m.peerOverrides.Popselect,
                builtinThemeOverrides: {
                  peers: {
                    InternalSelectMenu: {
                      height: "calc(var(--n-option-height) * 4.6)"
                    }
                  }
                },
                nodeProps: () => ({
                  style: {
                    justifyContent: "center"
                  }
                }),
                show: f === "page" ? !1 : f === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu,
                onUpdateShow: (s) => {
                  f !== "page" && (s ? f === "fast-backward" ? this.showFastBackwardMenu = s : this.showFastForwardMenu = s : (this.showFastBackwardMenu = !1, this.showFastForwardMenu = !1));
                },
                options: o.type !== "page" && o.options ? o.options : [],
                onUpdateValue: this.handleMenuSelect,
                scrollable: !0,
                showCheckmark: !1
              }, {
                default: () => T
              });
            }
          }), i("div", {
            class: [`${n}-pagination-item`, !O && `${n}-pagination-item--button`, {
              [`${n}-pagination-item--disabled`]: g < 1 || g >= h || l
            }],
            onClick: Z
          }, O ? O({
            page: g,
            pageSize: u,
            pageCount: h,
            itemCount: this.mergedItemCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex
          }) : i(y, {
            clsPrefix: n
          }, {
            default: () => this.rtlEnabled ? i(se, null) : i(re, null)
          })));
        case "size-picker":
          return !S && N ? i(lt, Object.assign({
            consistentMenuWidth: !1,
            placeholder: "",
            showCheckmark: !1,
            to: this.to
          }, this.selectProps, {
            size: b,
            options: I,
            value: u,
            disabled: l,
            theme: m.peers.Select,
            themeOverrides: m.peerOverrides.Select,
            onUpdateValue: G
          })) : null;
        case "quick-jumper":
          return !S && V ? i("div", {
            class: `${n}-pagination-quick-jumper`
          }, J ? J() : st(this.$slots.goto, () => [d.goto]), i(oe, {
            value: P,
            onUpdateValue: C,
            size: v,
            placeholder: "",
            disabled: l,
            theme: m.peers.Input,
            themeOverrides: m.peerOverrides.Input,
            onChange: H
          })) : null;
        default:
          return null;
      }
    }), k ? i("div", {
      class: `${n}-pagination-suffix`
    }, k({
      page: g,
      pageSize: u,
      pageCount: h,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null);
  }
});
export {
  Ht as default,
  gt as paginationProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/pagination/src/Pagination.js
// module id = 267
// module chunks = 67